import { post } from '@/utilities/onwardClient';
import { PREDELIVERY_SMS } from '@/constants/apiRoutes';

export const sendPredelivery = async ({ order_ids }) => {
    return post(PREDELIVERY_SMS, {
        order_ids,
    });
};
